// Import the functions you need from the SDKs you need

import firebase from 'firebase/compat/app';

// Your web app's Firebase configuration

let apiKey = process.env.VUE_APP_API_KEY
let authDomain = process.env.VUE_APP_AUTH_DOMAIN
let projectId = process.env.VUE_APP_PROJECT_ID
let storageBucket = process.env.VUE_APP_STORAGE_BUCKET
let messagingSenderId = process.env.VUE_APP_MESSAGING_SENDER_ID
let appId = process.env.VUE_APP_APP_ID

// const firebaseConfig = {
//   apiKey: apiKey,
//   authDomain: authDomain,
//   projectId: projectId,
//   storageBucket: storageBucket,
//   messagingSenderId: messagingSenderId,
//   appId: appId
// };

const firebaseConfig = {
  apiKey: "AIzaSyDz35tM3TfALZjOovVM9ntLREbXxDujv-s",
  authDomain: "continue-3d631.firebaseapp.com",
  projectId: "continue-3d631",
  storageBucket: "continue-3d631.firebasestorage.app",
  messagingSenderId: "1031221841164",
  appId: "1:1031221841164:web:2ac0aff139dba65cf90d29",
  measurementId: "G-95WD5VPR45"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyAjkT13YNBJk-rY0CRm6Wdjp-0MY9ucjiU",
//   authDomain: "myway-acb70.firebaseapp.com",
//   projectId: "myway-acb70",
//   storageBucket: "myway-acb70.firebasestorage.app",
//   messagingSenderId: "857395165080",
//   appId: "1:857395165080:web:2ca4fd86feedd7a41a9ded",
//   measurementId: "G-1Z43J2FQ4W"
// };

// Initialize Firebase
firebase.initializeApp(firebaseConfig)
console.log("start ");
let token = "9p13OZDuuxhVgmNEdTWdnGS3QE844PEzSDBqWzCc3bda9ee4";
